module.exports = __webpack_public_path__ + "img/candycane.af92b9f3.png";